import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { EmailBasedAuthorizeDirective } from '@platform/auth/email-based-authorize.directive';
import { BackButtonComponent } from '@platform/components/back-button/back-button.component';
import { selectPortalConfig } from '@platform/platform.selectors';
import { PortalConfig } from '@platform/platform.state';
import { RootState } from '@root/app.state';
import { AccessReportSectionComponent } from './access-report-section/access-report-section.component';
import { ChargingReportSectionComponent } from './charging-report-section/charging-report-section.component';
import { CreateCustomersSectionComponent } from './create-customers-section/create-customers-section.component';
import { TermsUpdatesSectionComponent } from './terms-updates-section/terms-updates-section.component';
import { AdminPageTitleComponent } from './ui/admin-page-title.component';
import { UserManagementLinkComponent } from './ui/user-management-link.component';
import { UpdateTemplateSectionComponent } from './update-template-section/update-template-section.component';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    BackButtonComponent,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    AdminPageTitleComponent,
    UserManagementLinkComponent,
    TermsUpdatesSectionComponent,
    CreateCustomersSectionComponent,
    AccessReportSectionComponent,
    UpdateTemplateSectionComponent,
    ChargingReportSectionComponent,
    EmailBasedAuthorizeDirective,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class AdminComponent {
  public readonly portalConfig: Signal<PortalConfig | null | undefined>;

  constructor(private store$: Store<RootState>) {
    this.portalConfig = toSignal(store$.pipe(select(selectPortalConfig)));
  }
}
